import { render, staticRenderFns } from "./add-show.vue?vue&type=template&id=5d9197dd&"
import script from "./add-show.vue?vue&type=script&lang=js&"
export * from "./add-show.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports